import React from 'react';

export default function TermsOfService() {
  return (
    <div className="w-full max-w-3xl mx-auto flex flex-col gap-6 text-gray-300 leading-relaxed font-sans px-2">
      <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent mb-2">
        Terms of Service
      </h1>
      <p className="text-sm text-gray-400">Last Updated: May 29, 2026</p>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">1. Agreement to Terms</h2>
        <p className="text-sm text-gray-400">
          By accessing or using GetQRPost (getqrpost.com), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you are prohibited from using the platform.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">2. Use License</h2>
        <p className="text-sm text-gray-400">
          GetQRPost is provided completely free of charge for both personal and commercial use. You are granted a non-exclusive license to:
        </p>
        <ul className="list-disc list-inside text-sm text-gray-400 ml-4 flex flex-col gap-1.5">
          <li>Generate unlimited custom QR codes for websites, hotspots, socials, and contact forms.</li>
          <li>Download and distribute generated high-resolution PNG image files without watermark constraints.</li>
          <li>Embed generated codes in physical prints, restaurant menus, stickers, and business setups.</li>
        </ul>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">3. Prohibited Conduct</h2>
        <p className="text-sm text-gray-400">
          You agree not to use our generator to construct QR codes pointing to malicious websites, phishing portals, illegal downloads, or scam operations. We reserve the right to report malicious destinations to cyber-security registries.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">4. Disclaimer of Warranties</h2>
        <p className="text-sm text-gray-400">
          GetQRPost tools are provided "as is" and "as available". We do not guarantee that the client-side compiler will operate without interruptions or that generated QR codes will scan correctly under extreme low-contrast or physically damaged conditions. We encourage testing all printed custom files before high-volume commercial production.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-100 mt-4">5. Governing Law</h2>
        <p className="text-sm text-gray-400">
          Any claim relating to GetQRPost's website shall be governed by local regulations and international digital laws without regard to conflict of law provisions.
        </p>
      </section>
    </div>
  );
}
